import { createWebHistory, createRouter } from 'vue-router'
import LandingPage from '@/pages/LandingPage.vue';

//------------------------------------------------------------
const routes = [
    { path: '/',                name: 'Home',       component: LandingPage },
];
// beforeEnter: (to, from) => {
    //   return true
// },
//------------------------------------------------------------
const router = createRouter({
    history: createWebHistory(),
    routes,
});
//------------------------------------------------------------
router.beforeEach((to, from, next) => {
    document.title = `SND | سند`;
    // document.title = `SND | ${to.name}`;
    next();
});
//------------------------------------------------------------
export default router
